<script>
export default {
  name: 'ProfileEditTabCompliance',
};
</script>

<template></template>

<style scoped lang="scss"></style>
